<template>
  <div>
    <div class="navigation">
      <div class="navigation_bottom">
        <img class="ai_assistant" ref="ai_assistant"
          src="https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/AI_Ass/AI_Ass.png" alt="">
        <span ref="scroll_bottom" class="scroll_bottom iconfont" @click="scrollToBottom">&#xe685; 回到底部</span>
      </div>
      <div class="navigation_items" ref="navigation_items">
        <div class="main_input" ref="main_input">
          <!-- 已上传视频缩略图区域 -->
          <div v-if="uploadVideos.length > 0" class="uploaded-thumbnails">
            <div v-for="(video, idx) in uploadVideos" :key="idx" class="thumbnail-item">
              <img :src="video.thumbnail" alt="视频缩略图" class="thumbnail-img">
              <div class="remove-btn" @click.stop="removeVideo(idx)">×</div>
            </div>
          </div>

          <!-- 输入框区域 -->
          <div class="input-area">
            <textarea name="" id="" :placeholder="textareaPlaceholder"
              v-model="textarea"
              @focus="handleTextareaFocus"
              @input="handleTextareaInput"
              @blur="handleTextareaBlur"
              @click="handleTextareaClick"
              :disabled="processing"></textarea>
            <button ref="up" class="sent iconfont" :class="{ 'has_input': canSend }" @click.stop="startTask" v-show="!scrollStatus" :disabled="!canSend || processing">
              <span v-if="!processing">&#xe688;</span>
              <span v-else class="rotating">&#xe6a4;</span>
            </button>
          </div>
          <!-- 底部功能按钮行 - 在输入框下方 -->
          <div class="input-options" @click.stop>
            <!-- 上传按钮 -->
            <div class="option-btn" @click.stop="handleVideoUpload">
              <span>上传视频</span>
            </div>
            <!-- 模式切换：视频剪辑 / 视频拆分 -->
            <div class="mode-tabs" @click.stop>
              <span
                v-for="m in modeOptions"
                :key="m.value"
                class="mode-tab"
                :class="{ 'is-active': currentMode === m.value }"
                @click.stop="selectMode(m.value)"
              >{{ m.label }}</span>
            </div>
            <!-- 增加秒数下拉（仅视频剪辑模式可用） -->
            <div v-if="currentMode === 'clip'" class="option-dropdown" @click.stop="togglePaddingMenu">
              <span class="option-label">增加秒数</span>
              <span class="option-value">{{ selectedPadding }}秒</span>
              <span class="iconfont arrow"></span>
              <div v-show="showPaddingMenu" class="dropdown-menu" @click.stop>
                <div
                  v-for="seconds in paddingOptions"
                  :key="seconds"
                  class="menu-item"
                  :class="{ active: selectedPadding === seconds }"
                  @click="selectPadding(seconds)"
                >
                  {{ seconds }}秒
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 放大后的发送按钮（绝对定位） -->
        <button ref="down" class="sent_expanded iconfont" :class="{ 'has_input': canSend }" @click.stop="startTask" v-show="scrollStatus" :disabled="!canSend || processing">
          <span v-if="!processing">&#xe688;</span>
          <span v-else class="rotating">&#xe6a4;</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import { getOssClient } from '@/utils/oss'
import { v4 as uuidv4 } from 'uuid'
import { genPrompt } from '@/api/promptVideo'
import { genOssImage } from '@/utils/ossPath'
import { getLastUsedBaseUrl, cudaIndexNum } from '@/utils/comfyUiVideoRequest'
import axios from 'axios'
import cuda from '@/utils/checkCuda'
import { getTaskEnd, getTaskStart } from '@/api/user'
import { VIDEO_CLIP } from '@/enums/common/modules'
import videoClipWorkflow from '@/api/json_api/视频剪辑.json'
import videoSplitWorkflow from '@/api/json_api/视频拆分.json'

export default {
  name: 'NaviGation_VideoClip',
  props: {
    initialChatHistory: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      textarea: '',
      uploadVideos: [], // 上传的视频数组（最多10条），每项包含 {url, thumbnail}
      processing: false,
      videoClipChatHistory: [],
      scrollStatus: false,
      // WebSocket
      ws: null,
      clientId: '',
      // 防止重复获取文件标志
      fileFetched: false,
      // 任务日志ID
      taskLogId: null,
      // 节点名称映射 - 根据视频剪辑工作流实际节点
      nodeNameMap: {
        5: 'Vidi Model Loader',
        6: 'CR Prompt Text',
        3: 'Vidi Temporal Retrieval',
        2: 'Vidi Clip Extractor'
      },
      currentExecutingNode: '', // 当前执行的节点名称
      outputFilenamePrefix: '', // 当前任务的输出文件名前缀
      // 批量处理相关
      batchQueue: [], // 待处理的视频队列
      batchResults: [], // 批量处理结果
      batchTotal: 0, // 批量总数
      batchCompleted: 0, // 批量已完成数
      isBatchProcessing: false, // 是否正在批量处理
      currentUserMessage: '', // 当前用户的提示词（用于批量处理）
      // 增加秒数选项（剪辑视频前后增加的秒数）
      selectedPadding: 0,
      paddingOptions: [0, 1, 2, 3, 4, 5],
      showPaddingMenu: false,
      // 工作模式：clip=视频剪辑，split=视频拆分
      currentMode: 'clip',
      modeOptions: [
        { label: '视频剪辑', value: 'clip' },
        { label: '视频拆分', value: 'split' }
      ],
      // 本次批量任务实际使用的模式（在 startTask 时快照，避免处理途中被切换影响）
      batchMode: 'clip',
      // 视频拆分工作流的节点名称映射
      splitNodeNameMap: {
        2: 'CR Prompt Text',
        14: 'Qwen3.5-Omni 多模态',
        16: 'ges Timecode Converter',
        18: 'ges Video Segment Splitter',
        22: 'ges OSS Batch Upload'
      }
    }
  },
  computed: {
    canSend() {
      return this.uploadVideos.length > 0
    },
    // 输入框占位提示随模式变化
    textareaPlaceholder() {
      return this.currentMode === 'split'
        ? '视频拆分模式：上传视频后将自动逐帧识别分镜并拆分为多个片段（无需描述）'
        : '请描述你想要剪辑的片段，例如：提取涂抹指甲油的片段、截取产品展示的部分...'
    }
  },
  created() {
    if (this.initialChatHistory && this.initialChatHistory.length > 0) {
      this.videoClipChatHistory = [...this.initialChatHistory]
    }
  },
  mounted() {
    // 点击外部关闭下拉菜单
    document.addEventListener('click', this.closeAllMenus)
    // 监听重新生成事件
    this.$root.$on('video-clip-regenerate', this.handleRegenerateFromParent)
    // 监听一键填入事件
    this.$root.$on('video-clip-refill', this.handleRefillFromParent)
    // 监听父组件裁剪历史后的同步事件
    this.$root.$on('video-clip-sync-history', this.handleHistorySync)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeAllMenus)
    // 移除事件监听
    this.$root.$off('video-clip-regenerate', this.handleRegenerateFromParent)
    this.$root.$off('video-clip-refill', this.handleRefillFromParent)
    this.$root.$off('video-clip-sync-history', this.handleHistorySync)
  },
  methods: {
    // 处理父组件裁剪历史后的同步
    handleHistorySync(trimmedHistory) {
      this.videoClipChatHistory = [...trimmedHistory]
    },
    // 处理视频上传（支持多选，最多10条）
    handleVideoUpload() {
      if (this.processing) return
      const remaining = 10 - this.uploadVideos.length
      if (remaining <= 0) {
        Message.warning('最多只能上传10条视频!')
        return
      }
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'video/*'
      input.multiple = true
      input.onchange = async (event) => {
        const files = Array.from(event.target.files)
        if (files.length === 0) return
        // 限制上传数量
        const toUpload = files.slice(0, remaining)
        if (files.length > remaining) {
          Message.warning(`最多还能上传${remaining}条视频，已自动截取前${remaining}条`)
        }
        for (const file of toUpload) {
          await this.processVideo(file)
        }
      }
      input.click()
    },

    // 处理视频文件
    async processVideo(file) {
      try {
        Message.info('正在上传视频...')

        const ossClient = await getOssClient()
        const tmp = '/input/'
        // 提取文件扩展名，文件名仅用时间戳+随机数（避免中文字符导致后端ASCII编码失败）
        const ext = file.name.substring(file.name.lastIndexOf('.')) || '.mp4'
        const fileName = `video_clip_${Date.now()}_${Math.floor(Math.random() * 99999)}${ext}`
        const result = await ossClient.put(tmp + fileName, file)

        console.log('OSS上传结果:', result)

        if (result.name) {
          const videoUrl = `https://mj-comfy-ui.oss-cn-shenzhen.aliyuncs.com/${result.name}`
          console.log('生成的视频URL:', videoUrl)

          // 先生成缩略图，再添加到数组
          const thumbnail = await this.generateVideoThumbnail(file)
          this.uploadVideos.push({
            url: videoUrl,
            thumbnail: thumbnail
          })
          console.log('视频已添加到列表，缩略图:', thumbnail)
          Message.success('视频上传成功!')
        } else {
          Message.error('视频上传失败，请重试!')
        }
      } catch (error) {
        console.error('上传视频失败:', error)
        Message.error('视频上传失败，请检查网络!')
      }
    },

    // 生成视频缩略图
    async generateVideoThumbnail(file) {
      return new Promise((resolve) => {
        const video = document.createElement('video')
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')

        video.preload = 'auto'
        video.muted = true
        video.src = URL.createObjectURL(file)

        // 设置超时
        const timeout = setTimeout(() => {
          console.warn('视频缩略图生成超时，使用默认占位图')
          URL.revokeObjectURL(video.src)
          resolve('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjgwIiBoZWlnaHQ9IjgwIiBmaWxsPSIjMzMzIi8+PHRleHQgeD0iNDAiIHk9IjQ1IiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMTAiIGZpbGw9IiNmZmYiIHRleHQtYW5jaG9yPSJtaWRkbGUiPuS5meaBrzwvdGV4dD48L3N2Zz4=')
        }, 10000)

        video.onloadeddata = () => {
          console.log('视频数据加载成功:', file.name)
          // 跳到视频的中间位置
          video.currentTime = Math.min(1, video.duration / 2)
        }

        video.onseeked = () => {
          console.log('视频seek完成，开始生成缩略图')
          clearTimeout(timeout)
          // 设置canvas尺寸为视频尺寸
          canvas.width = video.videoWidth
          canvas.height = video.videoHeight
          // 绘制当前帧到canvas
          context.drawImage(video, 0, 0, canvas.width, canvas.height)
          // 转换为base64图片
          const thumbnail = canvas.toDataURL('image/jpeg', 0.8)
          console.log('缩略图生成成功，长度:', thumbnail.length)
          // 清理资源
          URL.revokeObjectURL(video.src)
          resolve(thumbnail)
        }

        video.onerror = (error) => {
          console.error('视频加载失败:', error)
          clearTimeout(timeout)
          URL.revokeObjectURL(video.src)
          // 返回默认占位图
          resolve('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjgwIiBoZWlnaHQ9IjgwIiBmaWxsPSIjMzMzIi8+PHRleHQgeD0iNDAiIHk9IjQ1IiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMTAiIGZpbGw9IiNmZmYiIHRleHQtYW5jaG9yPSJtaWRkbGUiPuS5meaBrzwvdGV4dD48L3N2Zz4=')
        }
      })
    },

    // 移除视频（按索引）
    removeVideo(index) {
      this.uploadVideos.splice(index, 1)
    },

    // 关闭所有下拉菜单
    closeAllMenus() {
      this.showPaddingMenu = false
    },

    // 处理来自父组件的重新生成请求
    handleRegenerateFromParent(regenerateData) {
      if (!regenerateData) return
      console.log('接收到重新生成请求:', regenerateData)
      this.textarea = regenerateData.content
      this.uploadVideos = regenerateData.videos || []
      sessionStorage.removeItem('video_clip_regenerate')
      this.$nextTick(() => {
        this.startTask()
      })
    },

    // 处理来自父组件的一键填入请求（仅填入，不自动发送）
    handleRefillFromParent(refillData) {
      if (!refillData) return
      console.log('接收到一键填入请求:', refillData)
      this.textarea = refillData.content || ''
      this.uploadVideos = refillData.videos || []
      // 展开输入框
      if (!this.scrollStatus) {
        this.handleScroll(true)
      }
    },

    // 处理 textarea 获得焦点
    handleTextareaFocus() {
      if (!this.scrollStatus) {
        this.handleScroll(true)
      }
    },
    // 处理 textarea 输入
    handleTextareaInput() {
      if (!this.scrollStatus) {
        this.handleScroll(true)
      }
    },
    // 处理 textarea 失去焦点
    handleTextareaBlur() {
      // 不做任何处理，保持当前状态
    },
    // 处理 textarea 点击
    handleTextareaClick() {
      if (!this.scrollStatus) {
        this.handleScroll(true)
      }
    },
    // 导航栏状态
    handleScroll(val) {
      if (val) {
        if (this.$refs.navigation_items) {
          this.$refs.navigation_items.style.width = '70%'
        }
        if (this.$refs.ai_assistant) this.$refs.ai_assistant.style.opacity = 1
        if (this.$refs.scroll_bottom) this.$refs.scroll_bottom.style.opacity = 1
        this.scrollStatus = true
      } else {
        if (this.$refs.navigation_items) {
          this.$refs.navigation_items.style.width = '60%'
        }
        if (this.$refs.ai_assistant) this.$refs.ai_assistant.style.opacity = 0
        if (this.$refs.scroll_bottom) this.$refs.scroll_bottom.style.opacity = 0
        this.scrollStatus = false
      }
    },
    // 回滚到底部
    scrollToBottom() {
      if (this.scrollStatus) {
        this.$emit('scrollToBottom')
      }
    },

    // 切换增加秒数菜单
    togglePaddingMenu() {
      this.showPaddingMenu = !this.showPaddingMenu
    },

    // 切换工作模式（视频剪辑 / 视频拆分）
    selectMode(mode) {
      if (this.processing) {
        Message.warning('任务处理中，暂不能切换模式')
        return
      }
      this.currentMode = mode
      this.showPaddingMenu = false
    },

    // 选择增加秒数
    selectPadding(seconds) {
      this.selectedPadding = seconds
      this.showPaddingMenu = false
    },

    // 替换工作流中的动态变量
    replaceWorkflowVariables(workflow, videoUrl, userPrompt, paddingSeconds) {
      const workflowCopy = JSON.parse(JSON.stringify(workflow))
      console.log('🔍 开始替换工作流变量...')
      console.log('参数:', { videoUrl, userPrompt, paddingSeconds })

      // 生成动态文件名前缀（时间戳+随机数，避免多用户冲突）
      const timestamp = Date.now()
      const randomNum = Math.floor(Math.random() * 99999)
      // 拆分模式使用独立前缀，便于任务完成后按前缀探测 OSS 上的片段文件
      this.outputFilenamePrefix = this.batchMode === 'split'
        ? `videosplit_${timestamp}_${randomNum}`
        : `vidi_clip_${timestamp}_${randomNum}`
      console.log('📄 生成的文件名前缀:', this.outputFilenamePrefix)

      // 遍历所有节点替换变量
      for (const nodeId in workflowCopy) {
        const node = workflowCopy[nodeId]
        if (node.inputs) {
          for (const inputKey in node.inputs) {
            const inputValue = node.inputs[inputKey]
            if (typeof inputValue === 'string') {
              if (inputValue.includes('{{VIDEO_URL}}')) {
                node.inputs[inputKey] = videoUrl
                console.log(`✅ 节点${nodeId}.${inputKey}: {{VIDEO_URL}} -> ${videoUrl}`)
              } else if (inputValue.includes('{{USER_PROMPT}}')) {
                node.inputs[inputKey] = inputValue.replace('{{USER_PROMPT}}', userPrompt)
                console.log(`✅ 节点${nodeId}.${inputKey}: {{USER_PROMPT}} -> ${userPrompt}`)
              } else if (inputValue.includes('{{OUTPUT_FILENAME_PREFIX}}')) {
                // 子串替换：支持形如 "{{OUTPUT_FILENAME_PREFIX}}_{index}.mp4" 的文件名模式
                node.inputs[inputKey] = inputValue.replace('{{OUTPUT_FILENAME_PREFIX}}', this.outputFilenamePrefix)
                console.log(`✅ 节点${nodeId}.${inputKey}: {{OUTPUT_FILENAME_PREFIX}} -> ${node.inputs[inputKey]}`)
              } else if (inputValue.includes('{{PADDING_SECONDS}}')) {
                // padding_seconds 在工作流中需要数字类型，将占位符替换后转回 Number
                node.inputs[inputKey] = Number(paddingSeconds) || 1
                console.log(`✅ 节点${nodeId}.${inputKey}: {{PADDING_SECONDS}} -> ${node.inputs[inputKey]}`)
              }
            }
          }
        }
      }

      console.log('🔍 替换后的工作流:', JSON.stringify(workflowCopy, null, 2))
      return workflowCopy
    },

    // 开始任务（批量顺序处理）
    async startTask() {
      if (!this.canSend || this.processing) {
        return
      }

      // 确保放大状态
      if (!this.scrollStatus) {
        this.handleScroll(true)
      }

      if (this.uploadVideos.length === 0) {
        Message.warning('请先上传视频!')
        return
      }

      const userMessage = this.textarea.trim()
      // 验证提示词（视频拆分模式无需描述，可不填）
      const isSplit = this.currentMode === 'split'
      if (!userMessage && !isSplit) {
        Message.warning('请输入视频剪辑提示词！例如：提取涂抹指甲油的片段')
        return
      }
      const userVideos = [...this.uploadVideos]

      // 快照本次任务使用的模式
      this.batchMode = this.currentMode

      // 清空输入
      this.textarea = ''
      this.uploadVideos = []

      // 初始化批量处理队列
      this.batchQueue = [...userVideos]
      this.batchResults = []
      this.batchTotal = userVideos.length
      this.batchCompleted = 0
      this.isBatchProcessing = true
      this.currentUserMessage = userMessage // 保存提示词供后续使用

      // 添加用户消息到历史（包含所有视频）
      this.videoClipChatHistory.push({
        role: 'user',
        content: userMessage || (isSplit ? `视频拆分（共${userVideos.length}条）` : `使用默认设置进行视频剪辑（共${userVideos.length}条）`),
        videos: userVideos,
        timestamp: new Date().toISOString()
      })

      // 添加AI占位消息（用于显示加载框和结果）
      // 拆分模式下每个视频会产生多个片段，片段数未知，先用单个 loading 占位，完成后动态追加
      const videoSlots = isSplit
        ? [{ status: 'loading' }]
        : userVideos.map(() => ({ status: 'loading' }))
      this.videoClipChatHistory.push({
        role: 'assistant',
        content: isSplit ? `正在拆分 ${1}/${userVideos.length} 条视频...` : `正在处理 ${1}/${userVideos.length} 条视频...`,
        videoSlots: videoSlots,
        isSplit: isSplit,
        totalVideos: userVideos.length,
        completedVideos: 0,
        currentExecutingNode: '', // 将节点信息存储在消息中
        timestamp: new Date().toISOString()
      })

      // 更新界面
      this.$emit('chatUpdate', this.videoClipChatHistory)
      this.$emit('aiTyping', true)

      this.processing = true

      // 清空 textarea 后立即强制保持放大状态
      this.$nextTick(() => {
        this.handleScroll(true)
      })

      // 开始顺序处理第一条视频
      await this.processNextInBatch()
    },

    // 处理批量队列中的下一条视频
    async processNextInBatch() {
      console.log('🔄 processNextInBatch 被调用')
      console.log('📊 batchQueue剩余:', this.batchQueue.length)
      console.log('📊 batchCompleted:', this.batchCompleted)
      console.log('📊 batchTotal:', this.batchTotal)
      console.log('📊 batchResults:', JSON.stringify(this.batchResults, null, 2))

      if (this.batchQueue.length === 0) {
        // 所有视频处理完毕
        this.isBatchProcessing = false
        this.processing = false
        this.$emit('aiTyping', false)
        this.$emit('nodeUpdate', '')
        Message.success(this.batchMode === 'split' ? `全部${this.batchTotal}条视频拆分完成!` : `全部${this.batchTotal}条视频剪辑完成!`)
        return
      }

      // 取出队列中的第一条
      const currentVideo = this.batchQueue.shift()
      const userMessage = this.currentUserMessage || ''
      console.log(`🎬 正在处理第 ${this.batchCompleted + 1}/${this.batchTotal} 条视频`)
      console.log('🎬 当前视频对象:', currentVideo)

      try {
        console.log('🎬 视频剪辑任务开始...')
        console.log('📝 提示词:', userMessage)
        console.log('🎬 视频URL:', currentVideo.url)

        // 根据模式选择工作流（拆分模式仅替换 {{VIDEO_URL}}，剪辑模式额外替换提示词/秒数等）
        const activeWorkflow = this.batchMode === 'split' ? videoSplitWorkflow : videoClipWorkflow
        const promptData = this.replaceWorkflowVariables(
          activeWorkflow,
          currentVideo.url,
          userMessage,
          this.selectedPadding
        )

        console.log('👍 工作流替换完成，当前模式:', this.batchMode)

        // 打印关键节点，确认变量替换正确
        if (this.batchMode === 'split') {
          console.log('🔍 2号节点(视频URL):', JSON.stringify(promptData['2'], null, 2))
          console.log('🔍 22号节点(OSS批量上传):', JSON.stringify(promptData['22'], null, 2))
        } else {
          console.log('🔍 6号节点(视频URL):', JSON.stringify(promptData['6'], null, 2))
          console.log('🔍 3号节点(时序检索):', JSON.stringify(promptData['3'], null, 2))
          console.log('🔍 2号节点(剪辑提取):', JSON.stringify(promptData['2'], null, 2))
        }

        this.clientId = uuidv4()
        const data = {
          prompt: promptData,
          client_id: this.clientId
        }

        console.log('🚀 准备发送视频剪辑任务...')
        console.log('📦 客户端ID:', this.clientId)
        console.log('📦 工作流节点数量:', Object.keys(promptData).length)

        // 发送 Prompt 请求
        const result = await genPrompt(data)

        console.log('📨 genPrompt 返回结果:', result)

        if (result && result.prompt_id) {
          console.log('✅ 任务提交成功，promptId:', result.prompt_id)
          // 监听 WebSocket 进度
          await this.listenToBatchProgress(result.prompt_id, userMessage, currentVideo)
        } else {
          throw new Error('任务提交失败')
        }
      } catch (error) {
        console.error('❗ 视频剪辑失败:', error)
        let errorMessage = '视频剪辑失败，请稍后再试!'
        if (error.response) {
          console.error('⚠️ 服务器返回错误:', error.response.status)
          errorMessage = `服务器错误: ${error.response.status}`
        } else if (error.message) {
          errorMessage = error.message
        }
        // 标记当前视频为失败
        this.batchCompleted++
        this.batchResults.push({ video: currentVideo, error: true })
        this.updateAssistantMessage()
        this.$emit('chatUpdate', this.videoClipChatHistory)
        Message.error(errorMessage)
        // 继续处理下一条
        await this.processNextInBatch()
      }
    },

    // 更新AI助手消息（批量处理进度）
    updateAssistantMessage() {
      console.log('🔍 updateAssistantMessage 被调用')
      console.log('📊 batchResults:', JSON.stringify(this.batchResults, null, 2))
      console.log('📊 videoClipChatHistory:', JSON.stringify(this.videoClipChatHistory, null, 2))
      // 找到最后一条AI消息
      let lastAiIndex = -1
      for (let i = this.videoClipChatHistory.length - 1; i >= 0; i--) {
        if (this.videoClipChatHistory[i].role === 'assistant') {
          lastAiIndex = i
          break
        }
      }
      if (lastAiIndex === -1) {
        console.warn('⚠️ 未找到AI消息')
        return
      }

      const aiMessage = this.videoClipChatHistory[lastAiIndex]
      console.log('📨 AI消息对象:', aiMessage)

      // 拆分模式：每条视频产生多个片段，将所有片段平铺为 slots
      if (aiMessage.isSplit) {
        const slots = []
        for (const r of this.batchResults) {
          if (r.error) {
            slots.push({ status: 'error' })
          } else if (r.resultVideos && r.resultVideos.length) {
            for (const v of r.resultVideos) {
              slots.push({ status: 'done', video: { name: v.name || '', url: v.url || '' } })
            }
          }
        }
        // 还有视频未处理完，追加一个 loading 占位
        if (this.batchCompleted < this.batchTotal) {
          slots.push({ status: 'loading' })
        }
        aiMessage.videoSlots = slots
        aiMessage.completedVideos = this.batchCompleted
        if (this.batchCompleted < this.batchTotal) {
          const nodeInfo = this.currentExecutingNode ? ` - ${this.currentExecutingNode}` : ''
          aiMessage.content = `正在拆分 ${this.batchCompleted + 1}/${this.batchTotal} 条视频${nodeInfo}`
        } else {
          const segCount = slots.filter(s => s.status === 'done').length
          const failCount = this.batchResults.filter(r => r.error).length
          aiMessage.content = segCount > 0
            ? `视频拆分完成！共 ${segCount} 个片段${failCount > 0 ? `（${failCount} 条视频失败）` : ''}`
            : '抱歉，视频拆分均失败'
          aiMessage.isError = segCount === 0
        }
        const updatedSplitMessage = { ...aiMessage, videoSlots: [...aiMessage.videoSlots] }
        this.$set(this.videoClipChatHistory, lastAiIndex, updatedSplitMessage)
        return
      }

      // 确保 videoSlots 存在
      if (!aiMessage.videoSlots) {
        aiMessage.videoSlots = []
        for (let i = 0; i < this.batchTotal; i++) {
          aiMessage.videoSlots.push({ status: 'loading' })
        }
      }

      console.log('📦 更新前的videoSlots:', JSON.stringify(aiMessage.videoSlots, null, 2))

      // 根据batchResults更新对应slot - 使用Vue.$set确保响应式更新
      for (let i = 0; i < this.batchResults.length; i++) {
        const result = this.batchResults[i]
        console.log(`🔄 处理batchResults[${i}]:`, result)
        if (result.error) {
          this.$set(aiMessage.videoSlots, i, { status: 'error' })
          console.log(`❌ 设置slot[${i}]为error`)
        } else if (result.resultVideo) {
          // 确保视频对象结构正确
          const videoObj = {
            status: 'done',
            video: {
              name: result.resultVideo.name || '',
              url: result.resultVideo.url || ''
            }
          }
          console.log('🎬 设置视频slot:', i, videoObj)
          this.$set(aiMessage.videoSlots, i, videoObj)
          console.log(`✅ 设置slot[${i}]为done, URL:`, result.resultVideo.url)
        } else {
          console.warn(`⚠️ batchResults[${i}]没有resultVideo字段`)
        }
      }

      console.log('📦 更新后的videoSlots:', JSON.stringify(aiMessage.videoSlots, null, 2))

      // 更新已完成数
      aiMessage.completedVideos = this.batchCompleted

      // 更新content：显示进度或节点信息
      if (this.batchCompleted < this.batchTotal) {
        // 还在处理中，显示节点信息和进度
        const nodeInfo = this.currentExecutingNode ? ` - ${this.currentExecutingNode}` : ''
        aiMessage.content = `正在处理 ${this.batchCompleted + 1}/${this.batchTotal} 条视频${nodeInfo}`
      } else {
        // 全部完成
        const successCount = this.batchResults.filter(r => !r.error).length
        aiMessage.content = successCount > 0
          ? `视频剪辑完成！成功 ${successCount}/${this.batchTotal} 条`
          : '抱歉，所有视频剪辑均失败'
        aiMessage.isError = successCount === 0
      }
      // 强制响应式更新 - 重新创建整个消息对象和videoSlots数组
      const updatedMessage = {
        ...aiMessage,
        videoSlots: [...aiMessage.videoSlots]
      }
      this.$set(this.videoClipChatHistory, lastAiIndex, updatedMessage)
    },

    // 监听批量处理中单条视频的进度
    async listenToBatchProgress(promptId, taskPrompt, taskVideo) {
      this.fileFetched = false
      this.ws = new WebSocket(`${getLastUsedBaseUrl()}/ws?clientId=${this.clientId}`)
      const wsTimeout = setTimeout(() => {
        Message.warning('网络连接超时，尝试继续获取结果...')
        this.ws.close()
        // 超时后尝试直接获取结果
        if (!this.fileFetched) {
          this.fileFetched = true
          this.fetchBatchResultVideo(promptId)
        }
      }, 30000)
      this.ws.onopen = () => {
        console.log('✅ WebSocket 连接成功')
        getTaskStart({
          type: VIDEO_CLIP,
          prompt: taskPrompt || '',
          input_images: taskVideo && taskVideo.url ? [taskVideo.url] : []
        }).then(rep => {
          this.taskLogId = rep.data.task.id
        })
        clearTimeout(wsTimeout)
      }
      this.ws.onmessage = async (event) => {
        clearTimeout(wsTimeout)
        const data = event.data
        if (typeof data === 'string') {
          try {
            const msg = JSON.parse(data)
            if (msg.type !== 'crystools.monitor') {
              console.log('📡 收到消息:', msg)
            }

            if (msg.type === 'executing') {
              const execData = msg.data
              if (execData.node === null && execData.prompt_id === promptId) {
                console.log(`✅ 第 ${this.batchCompleted + 1}/${this.batchTotal} 条视频剪辑完成`)
                this.currentExecutingNode = ''
                this.$emit('nodeUpdate', '')
                // 更新消息内容
                this.updateAssistantMessage()
                this.$emit('chatUpdate', this.videoClipChatHistory)
                this.ws.close()
                if (!this.fileFetched) {
                  this.fileFetched = true
                  await this.fetchBatchResultVideo(promptId)
                }
              } else if (execData.node !== null) {
                console.log(`🔄 正在执行节点: ${execData.node}`)
                const activeNodeMap = this.batchMode === 'split' ? this.splitNodeNameMap : this.nodeNameMap
                const nodeName = activeNodeMap[execData.node] || `执行节点 ${execData.node}`
                this.currentExecutingNode = `${nodeName} (${this.batchCompleted + 1}/${this.batchTotal})`
                this.$emit('nodeUpdate', this.currentExecutingNode)
                // 更新消息内容，显示节点信息
                this.updateAssistantMessage()
                this.$emit('chatUpdate', this.videoClipChatHistory)
              }
            } else if (msg.type === 'progress') {
              const value = msg.data.value
              const max = msg.data.max
              const current = (value / max * 100).toFixed(2)
              console.log(`📈 进度: ${current}%`)
              this.$emit('progressUpdate', current)
            } else if (msg.type === 'status') {
              console.log('📊 状态更新:', msg.data)
              // 注意: 不在status消息中触发checkTaskStatus
              // 因为批量处理流程由 executing(null) -> fetchBatchResultVideo -> processNextInBatch 驱动
              // 如果在这里触发checkTaskStatus，会导致调用非批量版fetchResultVideo，破坏批量流程
            } else if (msg.type === 'execution_error') {
              console.error('❌ 执行错误:', msg.data)
              this.batchCompleted++
              this.batchResults.push({ video: '', error: true })
              this.updateAssistantMessage()
              this.$emit('chatUpdate', this.videoClipChatHistory)
              Message.error(`第 ${this.batchCompleted} 条视频剪辑失败`)
              this.ws.close()
              // 继续处理下一条
              await this.processNextInBatch()
            }
          } catch (error) {
            console.error('WebSocket消息解析失败:', error)
          }
        }
      }
      this.ws.onclose = async () => {
        console.log('🔌 WebSocket 连接关闭')
        try {
          const index = await cudaIndexNum()
          if (index) {
            await cuda.changeCudaCurrentStatus(index, 'leisure')
          }
        } catch (error) {
          console.log(error)
        }
      }
      this.ws.onerror = (error) => {
        console.error('❌ WebSocket 错误:', error)
        Message.error('WebSocket 连接错误')
        this.processing = false
        this.$emit('aiTyping', false)
      }
    },

    // 检查任务状态
    async checkTaskStatus(promptId) {
      try {
        console.log('🔍 检查任务状态:', promptId)
        const historyRequest = axios.create({
          baseURL: getLastUsedBaseUrl(),
          timeout: 300000,
          headers: {
            'Content-Type': 'application/json'
          }
        })
        const response = await historyRequest.get(`/history/${promptId}`)
        const promptInfo = response.data[promptId]
        console.log('📝 任务历史信息:', promptInfo)

        if (!promptInfo) {
          console.error('❌ 找不到任务信息，任务可能还在排队中...')
          return
        }

        if (promptInfo.status) {
          console.log('📊 任务状态:', promptInfo.status.status_str)
          if (promptInfo.status.status_str === 'success') {
            if (!this.fileFetched) {
              this.fileFetched = true
              // 批量模式使用fetchBatchResultVideo，非批量模式使用fetchResultVideo
              if (this.isBatchProcessing) {
                await this.fetchBatchResultVideo(promptId)
              } else {
                await this.fetchResultVideo(promptId)
              }
            }
          } else if (promptInfo.status.status_str === 'error') {
            console.error('❌ 任务执行失败:', promptInfo.status)
            if (this.isBatchProcessing) {
              // 批量模式下标记失败并继续下一条
              this.batchCompleted++
              this.batchResults.push({ video: '', error: true })
              this.updateAssistantMessage()
              this.$emit('chatUpdate', this.videoClipChatHistory)
              Message.error(`第 ${this.batchCompleted} 条视频剪辑失败`)
              await this.processNextInBatch()
            } else {
              this.videoClipChatHistory.push({
                role: 'assistant',
                content: '抱歉，似乎发生了某些问题',
                timestamp: new Date().toISOString(),
                isError: true
              })
              this.$emit('chatUpdate', this.videoClipChatHistory)
              Message.error('任务执行失败，请检查工作流配置')
              this.processing = false
              this.$emit('aiTyping', false)
              if (this.ws) this.ws.close()
            }
          }
        }
      } catch (error) {
        console.error('🚫 检查任务状态失败:', error)
      }
    },

    // 记录任务结束
    async recordTaskEnd(videoUrl) {
      try {
        const info = {
          details: [{ path: videoUrl }]
        }
        await getTaskEnd({ result: JSON.stringify(info) }, this.taskLogId)
      } catch (error) {
        console.error('记录任务结束失败:', error)
      }
    },

    // 通用方法：从节点输出中递归提取 OSS URL
    extractOssUrlFromOutput(output) {
      if (!output) return null
      const ossBaseUrl = 'https://mj-comfy-ui.oss-cn-shenzhen.aliyuncs.com/'
      // 递归搜索对象/数组中的字符串值
      const search = (obj) => {
        if (typeof obj === 'string') {
          // 匹配包含 video_vidi_clip 或 vidi_clips 或以 http 开头的视频路径
          if ((obj.includes('video_vidi_clip') || obj.includes('vidi_clips')) && (obj.endsWith('.mp4') || obj.endsWith('.webm') || obj.endsWith('.mov'))) {
            // 如果是相对路径，拼上 OSS 域名
            if (!obj.startsWith('http')) {
              return ossBaseUrl + obj
            }
            return obj
          }
          if (obj.startsWith('http') && (obj.includes('.mp4') || obj.includes('.webm') || obj.includes('.mov'))) {
            return obj
          }
        } else if (Array.isArray(obj)) {
          for (const item of obj) {
            const result = search(item)
            if (result) return result
          }
        } else if (typeof obj === 'object' && obj !== null) {
          for (const key of Object.keys(obj)) {
            const result = search(obj[key])
            if (result) return result
          }
        }
        return null
      }
      const found = search(output)
      if (found) {
        console.log('🎬 extractOssUrlFromOutput 找到:', found)
      }
      return found
    },

    // 通用方法：从节点输出中递归提取全部 OSS 视频 URL（用于视频拆分多片段）
    extractAllOssUrlsFromOutput(output) {
      const ossBaseUrl = 'https://mj-comfy-ui.oss-cn-shenzhen.aliyuncs.com/'
      const urls = []
      const seen = new Set()
      const isVideo = (s) => /\.(mp4|webm|mov)(\?|#|$)/i.test(s)
      const pushUrl = (u) => {
        if (u && !seen.has(u)) {
          seen.add(u)
          urls.push(u)
        }
      }
      const walk = (obj) => {
        if (typeof obj === 'string') {
          const s = obj.trim()
          // 可能是被字符串化的 JSON 数组/对象，尝试二次解析
          if ((s.startsWith('[') && s.endsWith(']')) || (s.startsWith('{') && s.endsWith('}'))) {
            try {
              walk(JSON.parse(s))
              return
            } catch (e) {
              // 非 JSON，继续按普通字符串处理
            }
          }
          if (s.startsWith('http') && isVideo(s)) {
            pushUrl(s)
          } else if (s.startsWith('oss://')) {
            // oss://bucket/path -> https://bucket.endpoint/path，此处统一拼接已知域名
            const withoutScheme = s.replace(/^oss:\/\//, '')
            const slashIdx = withoutScheme.indexOf('/')
            if (slashIdx > -1 && isVideo(withoutScheme)) {
              pushUrl(ossBaseUrl + withoutScheme.slice(slashIdx + 1))
            }
          } else if (isVideo(s) && !s.startsWith('http')) {
            pushUrl(ossBaseUrl + s.replace(/^\/+/, ''))
          }
        } else if (Array.isArray(obj)) {
          obj.forEach(walk)
        } else if (obj && typeof obj === 'object') {
          Object.keys(obj).forEach(k => walk(obj[k]))
        }
      }
      walk(output)
      // 按文件名中的数字序号排序（如 videotext_0.mp4 / videotext_1.mp4），保证片段顺序
      const indexOf = (u) => {
        const m = u.match(/(\d+)(?=[^/]*$)/)
        return m ? Number(m[1]) : 0
      }
      urls.sort((a, b) => indexOf(a) - indexOf(b))
      console.log('🎬 extractAllOssUrlsFromOutput 找到', urls.length, '个片段:', urls)
      return urls
    },

    // 拆分模式兜底：按任务唯一前缀逐个探测 OSS 上的片段文件（history.outputs 为空时使用）
    async probeSplitSegments() {
      const base = 'https://mj-comfy-ui.oss-cn-shenzhen.aliyuncs.com/vidi_videp_library/Video_split/'
      const prefix = this.outputFilenamePrefix
      if (!prefix) return []
      // 给 OSS 上传/传播一点缓冲时间
      await new Promise(resolve => setTimeout(resolve, 1500))
      const urls = []
      let miss = 0
      // 节点会把 {index} 替换为补零序号（如 001/002）且可能从 1 开始，
      // 因此每个序号依次尝试 3位补零 / 2位补零 / 不补零 三种文件名，命中任一即视为该片段存在
      const padCandidates = (i) => [String(i).padStart(3, '0'), String(i).padStart(2, '0'), String(i)]
      // 兼容 0-based / 1-based 与中间小幅缺号（连续 3 个序号未命中则停止）
      for (let i = 0; i < 200 && miss < 3; i++) {
        let hitUrl = null
        for (const cand of padCandidates(i)) {
          const url = `${base}${prefix}_${cand}.mp4`
          if (await this.probeUrlExists(url)) {
            hitUrl = url
            break
          }
        }
        if (hitUrl) {
          urls.push(hitUrl)
          miss = 0
        } else {
          miss++
        }
      }
      console.log('🔎 probeSplitSegments 探测到', urls.length, '个片段:', urls)
      return urls
    },

    // 探测单个 OSS 文件是否存在（带 Range 的 GET，仅取1字节）
    async probeUrlExists(url) {
      for (let attempt = 0; attempt < 2; attempt++) {
        try {
          // 用带 Range 的 GET（仅取1字节）代替 HEAD：下载功能已证明 OSS 对 GET 放行 CORS，比 HEAD 更稳
          await axios.get(url, {
            timeout: 8000,
            responseType: 'blob',
            headers: { Range: 'bytes=0-0' },
            validateStatus: (s) => s >= 200 && s < 300
          })
          return true
        } catch (e) {
          if (attempt === 0) await new Promise(resolve => setTimeout(resolve, 600))
        }
      }
      return false
    },

    // 获取批量处理结果视频URL
    async fetchBatchResultVideo(promptId) {
      try {
        const historyRequest = axios.create({
          baseURL: getLastUsedBaseUrl(),
          timeout: 300000,
          headers: {
            'Content-Type': 'application/json'
          }
        })
        const response = await historyRequest.get(`/history/${promptId}`)
        const promptInfo = response.data[promptId]
        console.log('📄 完整的promptInfo:', promptInfo)
        console.log('📄 promptInfo.outputs:', promptInfo.outputs)
        console.log('📄 promptInfo.status:', promptInfo.status)

        if (promptInfo.status.status_str === 'success') {
          // 打印完整的 promptInfo 结构以便诊断
          console.log('📄 完整 promptInfo 键:', Object.keys(promptInfo))
          console.log('📄 promptInfo.prompt:', promptInfo.prompt)
          console.log('📄 promptInfo.outputs:', promptInfo.outputs)
          console.log('📄 promptInfo.status:', promptInfo.status)
          if (promptInfo.meta) console.log('📄 promptInfo.meta:', promptInfo.meta)

          // ===== 视频拆分模式：从 22 号节点（OSS批量上传）提取全部片段 URL =====
          if (this.batchMode === 'split') {
            let segUrls = []
            if (promptInfo.outputs && promptInfo.outputs['22']) {
              segUrls = this.extractAllOssUrlsFromOutput(promptInfo.outputs['22'])
            }
            if (segUrls.length === 0 && promptInfo.outputs) {
              console.log('⚠️ 22号节点未获取到片段，遍历所有节点输出...')
              const collected = []
              for (const key of Object.keys(promptInfo.outputs)) {
                collected.push(...this.extractAllOssUrlsFromOutput(promptInfo.outputs[key]))
              }
              segUrls = [...new Set(collected)]
            }
            // 兜底：拆分工作流的节点不是 ComfyUI OUTPUT_NODE，history.outputs 为空，
            // 改为按任务唯一前缀探测 OSS 上的片段文件
            if (segUrls.length === 0) {
              console.log('⚠️ outputs 为空（符合预期），改为按前缀探测 OSS 片段文件，前缀:', this.outputFilenamePrefix)
              segUrls = await this.probeSplitSegments()
            }
            if (segUrls.length > 0) {
              const resultVideos = segUrls.map(u => ({ name: u.split('/').pop(), url: u }))
              console.log('✅ 拆分成功，共', resultVideos.length, '个片段')
              this.batchCompleted++
              this.batchResults.push({ error: false, resultVideos })
              this.updateAssistantMessage()
              this.$emit('chatUpdate', this.videoClipChatHistory)
              await this.recordTaskEnd(resultVideos[0].url)
              await this.processNextInBatch()
            } else {
              console.error('❌ 无法获取拆分片段 URL，promptInfo:', JSON.stringify(promptInfo, null, 2))
              this.batchCompleted++
              this.batchResults.push({ error: true })
              this.updateAssistantMessage()
              this.$emit('chatUpdate', this.videoClipChatHistory)
              Message.error('获取拆分片段失败，请检查工作流配置')
              await this.processNextInBatch()
            }
            return
          }

          // ===== 视频剪辑模式（原逻辑） =====
          // 视频剪辑工作流输出节点ID为2（VidiClipExtractor）
          const nodeId = '2'
          let videoUrl = null

          // 检查 outputs 是否存在
          if (!promptInfo.outputs || Object.keys(promptInfo.outputs).length === 0) {
            console.error('❌ outputs 为空！尝试从其他字段查找输出...')
            // 有些自定义节点可能将输出放在其他字段
            if (promptInfo.prompt && promptInfo.prompt.outputs) {
              console.log('🔍 在 prompt.outputs 中找到:', promptInfo.prompt.outputs)
            }
          }

          // 优先从 outputs 获取 oss_path
          if (promptInfo.outputs && promptInfo.outputs[nodeId]) {
            const nodeOutput = promptInfo.outputs[nodeId]
            console.log(`📊 ${nodeId}号节点输出:`, JSON.stringify(nodeOutput, null, 2))
            // VidiClipExtractor 输出格式可能是 gifs 数组或 videos 数组
            if (nodeOutput.gifs && nodeOutput.gifs.length > 0 && nodeOutput.gifs[0].oss_path) {
              const ossPath = nodeOutput.gifs[0].oss_path
              console.log('🎬 从 outputs.gifs 获取的OSS路径:', ossPath)
              videoUrl = genOssImage(ossPath)
            } else if (nodeOutput.videos && nodeOutput.videos.length > 0 && nodeOutput.videos[0].oss_path) {
              const ossPath = nodeOutput.videos[0].oss_path
              console.log('🎬 从 outputs.videos 获取的OSS路径:', ossPath)
              videoUrl = genOssImage(ossPath)
            } else {
              // 通用遍历：在 nodeOutput 中搜索任何包含 OSS URL 的字段
              videoUrl = this.extractOssUrlFromOutput(nodeOutput)
            }
          }

          // 兜底：遍历所有节点的 outputs 寻找含有 video_vidi_clip 的 OSS 路径
          if (!videoUrl && promptInfo.outputs) {
            console.log('⚠️ 主节点未获取到 oss_path，遍历所有节点输出...')
            for (const key of Object.keys(promptInfo.outputs)) {
              const output = promptInfo.outputs[key]
              videoUrl = this.extractOssUrlFromOutput(output)
              if (videoUrl) {
                console.log(`✅ 从节点 ${key} 的输出中找到视频URL:`, videoUrl)
                break
              }
            }
          }

          // 最终兜底：通过已知的 outputFilenamePrefix 直接拼接 OSS URL
          // VidiClipExtractor 可能使用不同的文件名格式和路径
          if (!videoUrl && this.outputFilenamePrefix) {
            const possiblePaths = [
              'tmp-comfyui/video_vidi_clip',
              'video_vidi_clip',
              'vidi_clips',
              'tmp-comfyui/vidi_clips',
              'comfyui/video_vidi_clip',
              'output/video_vidi_clip'
            ]
            const possibleNames = [
              `${this.outputFilenamePrefix}_000.mp4`,
              `${this.outputFilenamePrefix}.mp4`,
              `${this.outputFilenamePrefix}_001.mp4`,
              `${this.outputFilenamePrefix}_00001.mp4`,
              `${this.outputFilenamePrefix}_000.webm`,
              `${this.outputFilenamePrefix}_000.mov`
            ]
            const possibleUrls = []
            for (const path of possiblePaths) {
              for (const name of possibleNames) {
                possibleUrls.push(`https://mj-comfy-ui.oss-cn-shenzhen.aliyuncs.com/${path}/${name}`)
              }
            }
            console.log('🔧 尝试所有可能的URL组合，共', possibleUrls.length, '个')
            for (const url of possibleUrls) {
              try {
                await axios.head(url, { timeout: 10000 })
                console.log('✅ URL 验证成功:', url)
                videoUrl = url
                break
              } catch (e) {
                // 静默失败，继续尝试下一个
              }
            }
            if (!videoUrl) {
              // 如果所有URL都验证失败，使用默认路径作为最终兜底
              videoUrl = `https://mj-comfy-ui.oss-cn-shenzhen.aliyuncs.com/tmp-comfyui/video_vidi_clip/${this.outputFilenamePrefix}_000.mp4`
              console.log('⚠️ 所有URL验证失败，使用默认URL:', videoUrl)
            }
          }

          if (videoUrl) {
            const fileName = videoUrl.split('/').pop()
            const resultVideo = {
              name: fileName,
              url: videoUrl
            }

            console.log('✅ 成功获取视频URL:', videoUrl)
            console.log('📦 resultVideo 对象:', resultVideo)
            console.log('🔍 当前batchResults:', JSON.stringify(this.batchResults, null, 2))

            // 记录成功结果
            this.batchCompleted++
            this.batchResults.push({ video: resultVideo, error: false, resultVideo })
            console.log('🔍 推入后的batchResults:', JSON.stringify(this.batchResults, null, 2))
            this.updateAssistantMessage()
            this.$emit('chatUpdate', this.videoClipChatHistory)
            // 记录任务结束
            await this.recordTaskEnd(videoUrl)
            // 继续处理下一条
            await this.processNextInBatch()
          } else {
            console.error('❌ 无法获取视频URL')
            console.error(' batchCompleted:', this.batchCompleted)
            console.error('📄 outputFilenamePrefix:', this.outputFilenamePrefix)
            console.error('📄 promptInfo:', JSON.stringify(promptInfo, null, 2))
            this.batchCompleted++
            this.batchResults.push({ video: '', error: true })
            this.updateAssistantMessage()
            this.$emit('chatUpdate', this.videoClipChatHistory)
            Message.error('获取视频结果失败，请检查工作流配置')
            // 继续处理下一条
            await this.processNextInBatch()
          }
        } else {
          console.error('任务状态异常:', promptInfo.status)
          this.batchCompleted++
          this.batchResults.push({ video: '', error: true })
          this.updateAssistantMessage()
          this.$emit('chatUpdate', this.videoClipChatHistory)
          Message.error(`任务执行失败: ${promptInfo.status.status_str}`)
          // 继续处理下一条
          await this.processNextInBatch()
        }
      } catch (error) {
        console.error('获取视频失败：', error)
        console.error('错误详情:', error.response?.data || error.message)
        this.batchCompleted++
        this.batchResults.push({ video: '', error: true })
        this.updateAssistantMessage()
        this.$emit('chatUpdate', this.videoClipChatHistory)
        Message.error('获取生成结果失败，请查看控制台')
        // 继续处理下一条
        await this.processNextInBatch()
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-family: "icomoon";
  overflow: hidden;
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 25px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.active {
  background: @basicselect;
}

.navigation {
  position: absolute;
  width: calc(100vw - 80px);
  bottom: 15px;
  left: 100px;
  z-index: 8;
  transition: all 0.5s;

  .navigation_bottom {
    position: relative;
    width: 1536px;
    height: 50px;
    font-size: 23px;
    margin: 0 auto;
    justify-content: space-between;
    margin-bottom: 10px;

    .ai_assistant {
      position: absolute;
      bottom: -10px;
      width: 120px;
      height: 120px;
      opacity: 0;
      transition: all 0.5s;
    }

    .scroll_bottom {
      position: absolute;
      right: 0px;
      font-size: 20px;
      color: @font_white;
      background-color: #c1c1c1;
      padding: 10px 15px;
      cursor: pointer;
      border-radius: @border_radius_3;
      transition: all 0.5s;
      opacity: 0;
    }
  }

  .navigation_items {
    position: relative;
    width: 1336px;
    height: 220px;
    display: flex;
    flex-direction: column;
    background: rgba(235, 235, 235, 0.5);
    backdrop-filter: blur(10px);
    border: 1px solid @font_white;
    border-radius: @border_radius;
    transition: all 0.3s;
    margin: 0 auto;
    box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.2);

    .main_input {
      width: 100%;
      height: 220px;
      display: flex;
      flex-direction: column;
      padding: 15px 20px;
      gap: 10px;

      // 已上传视频缩略图区域
      .uploaded-thumbnails {
        display: flex;
        flex-wrap: nowrap;
        gap: 8px;
        overflow-x: auto;
        padding: 4px 0;
        flex-shrink: 0;
        height: 68px;

        &::-webkit-scrollbar {
          height: 4px;
        }

        &::-webkit-scrollbar-thumb {
          background: #d0d0d0;
          border-radius: 2px;
        }

        .thumbnail-item {
          position: relative;
          width: 60px;
          height: 60px;
          border-radius: 8px;
          overflow: hidden;
          flex-shrink: 0;
          border: 2px solid #e5e7eb;
          transition: all 0.3s;
          background: #000;

          &:hover {
            border-color: @morejoy;
            transform: scale(1.05);
          }

          .thumbnail-img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          .remove-btn {
            position: absolute;
            top: 3px;
            right: 3px;
            width: 18px;
            height: 18px;
            background: rgba(0, 0, 0, 0.6);
            color: white;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            cursor: pointer;
            transition: all 0.3s;

            &:hover {
              background: rgba(255, 0, 0, 0.8);
              transform: scale(1.1);
            }
          }
        }
      }

      // 输入框区域
      .input-area {
        flex: 1;
        display: flex;
        align-items: center;
        gap: 15px;
        position: relative;
        min-height: 60px;

        textarea {
          flex: 1;
          height: 100%;
          min-height: 60px;
          font-family: '微软雅黑';
          font-size: 23px;
          padding: 10px 20px;
          border: none;
          background: none;
          resize: none;
          outline: none;
        }

        .sent {
          position: relative;
          width: 60px;
          height: 60px;
          text-align: center;
          line-height: 60px;
          font-size: 35px;
          color: @font_white;
          border: none;
          border-radius: 30px;
          background-color: @font_gray;
          cursor: pointer;
          opacity: 0.7;
          transition: all 0.3s;

          &.has_input {
            background-color: @morejoy;
            opacity: 1;
          }

          &:hover:not(:disabled) {
            opacity: 1;
            font-size: 38px;
          }

          &:disabled {
            opacity: 0.3;
            cursor: not-allowed;
          }

          .rotating {
            animation: rotate 1s linear infinite;
          }
        }
      }

      // 底部功能按钮行
      .input-options {
        display: flex;
        gap: 10px;
        align-items: center;
        flex-shrink: 0;
        padding-top: 5px;

        .option-btn {
          padding: 8px 16px;
          background: rgba(255, 255, 255, 0.8);
          border: 1px solid #d0d0d0;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.3s;
          font-size: 14px;
          color: #666;

          &:hover {
            background: @morejoy;
            color: white;
            border-color: @morejoy;
          }

          span {
            white-space: nowrap;
          }
        }

        // 模式切换 tabs（视频剪辑 / 视频拆分）
        .mode-tabs {
          display: inline-flex;
          align-items: center;
          padding: 3px;
          background: #f2f3f5;
          border: 1px solid #d0d0d0;
          border-radius: 14px;
          gap: 2px;
          user-select: none;

          .mode-tab {
            padding: 5px 14px;
            font-size: 13px;
            color: #666;
            border-radius: 12px;
            cursor: pointer;
            transition: all 0.2s;
            white-space: nowrap;

            &:hover {
              color: @morejoy;
            }

            &.is-active {
              background: @morejoy;
              color: #fff;
              font-weight: 500;
            }
          }
        }

        // 增加秒数下拉
        .option-dropdown {
          position: relative;
          display: flex;
          align-items: center;
          gap: 5px;
          padding: 8px 12px;
          background: white;
          border: 1px solid #d0d0d0;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.3s;
          user-select: none;

          &:hover {
            border-color: @morejoy;
            background: #fff8f3;
          }

          .option-label {
            font-size: 12px;
            color: #999;
            font-weight: 400;
          }

          .option-value {
            font-size: 13px;
            color: #333;
            font-weight: 500;
          }

          .arrow {
            font-size: 12px;
            color: #999;
            transition: transform 0.3s;
          }

          .dropdown-menu {
            position: absolute;
            bottom: calc(100% + 5px);
            left: 0;
            min-width: 100%;
            background: white;
            border: 1px solid #e0e0e0;
            border-radius: 8px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            z-index: 100;
            overflow: hidden;

            .menu-item {
              padding: 10px 15px;
              font-size: 13px;
              color: #333;
              cursor: pointer;
              transition: all 0.2s;
              white-space: nowrap;

              &:hover {
                background: #fff8f3;
                color: @morejoy;
              }

              &.active {
                background: #fff8f3;
                color: @morejoy;
                font-weight: 500;

                &::after {
                  content: '✓';
                  float: right;
                  font-weight: bold;
                  margin-left: 8px;
                }
              }
            }
          }
        }
      }
    }

    /* 放大后的发送按钮（绝对定位） */
    .sent_expanded {
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
      width: 60px;
      height: 60px;
      text-align: center;
      line-height: 60px;
      font-size: 35px;
      color: @font_white;
      border: none;
      border-radius: 30px;
      background-color: @font_gray;
      cursor: pointer;
      opacity: 0.7;
      transition: all 0.3s;
      z-index: 10;

      &.has_input {
        background-color: @morejoy;
        opacity: 1;
      }

      &:hover:not(:disabled) {
        opacity: 1;
        font-size: 38px;
      }

      &:disabled {
        opacity: 0.3;
        cursor: not-allowed;
      }

      .rotating {
        animation: rotate 1s linear infinite;
      }
    }
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
